import {
  Button,
  Divider,
  InlineGrid,
  Link,
  Text,
  ButtonGroup,
  Icon,
  InlineStack,
  TextField,
} from "@shopify/polaris";
import { ComposeIcon, ExternalIcon, RefreshIcon } from "@shopify/polaris-icons";
import React from "react";

const ProductLabels = ({ data, handleProductLabelsChange }) => {
  return (
    <>
      <InlineGrid columns={["oneThird", "twoThirds"]}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            rowGap: "15px",
            paddingLeft: "30px",
            paddingTop: "20px",
            paddingBottom: "20px",
            width: "25vw",
          }}
        >
          <Text variant="headingLg" fontWeight="semibold">
            Product Labels
          </Text>
          <Text as="p">
            Custom Labels are used to structure your campaigns.
            <Link>Learn More</Link>
          </Text>
          <Text as="p">
            Shipping Labels is used to setup different Shipping Cost in the
            Merchant Center for different products
            <Link>Learn More</Link>
          </Text>
        </div>
        <div style={{ paddingTop: "10px", paddingBottom: "20px" }}>
          <InlineGrid columns={2}>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                rowGap: "5px",
                paddingBottom: "30px",
              }}
            >
              <TextField
                id="customLabel0"
                label="Custom Label 0"
                value={data?.customLabel0}
                onChange={handleProductLabelsChange}
                autoComplete="off"
              />
              <TextField
                id="customLabel2"
                label="Custom Label 2"
                value={data?.customLabel2}
                onChange={handleProductLabelsChange}
                autoComplete="off"
              />
              <TextField
                id="customLabel4"
                label="Custom Label 4"
                value={data?.customLabel4}
                onChange={handleProductLabelsChange}
                autoComplete="off"
              />
            </div>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                rowGap: "5px",
              }}
            >
              <TextField
                id="customLabel1"
                label="Custom Label 1"
                value={data?.customLabel1}
                onChange={handleProductLabelsChange}
                autoComplete="off"
              />
              <TextField
                id="customLabel3"
                label="Custom Label 3"
                value={data?.customLabel3}
                onChange={handleProductLabelsChange}
                autoComplete="off"
              />
            </div>
          </InlineGrid>
          <Divider />
          <InlineGrid columns={2}>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                paddingTop: "10px",
                paddingBottom: "20px",
                rowGap: "5px",
              }}
            >
              <TextField
                id="adsLabel"
                label="Ads Label"
                value={data?.adsLabel}
                onChange={handleProductLabelsChange}
                autoComplete="off"
              />
            </div>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                paddingTop: "10px",
                rowGap: "5px",
                paddingBottom: "20px",
              }}
            >
              <TextField
                id="adsGrouping"
                label="Ads Grouping"
                value={data?.adsGrouping}
                onChange={handleProductLabelsChange}
                autoComplete="off"
              />
            </div>
          </InlineGrid>
          <Divider />
          <InlineGrid columns={2}>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                paddingTop: "10px",
                paddingBottom: "20px",
                rowGap: "5px",
              }}
            >
              <TextField
                id="shippingLabel"
                label="Shipping Label"
                value={data?.shippingLabel}
                onChange={handleProductLabelsChange}
                autoComplete="off"
              />
            </div>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                paddingTop: "10px",
                rowGap: "5px",
                paddingBottom: "20px",
              }}
            >
              <TextField
                id="returnPolicyLabel"
                label="Return Policy Label"
                value={data?.returnPolicyLabel}
                onChange={handleProductLabelsChange}
                autoComplete="off"
              />
            </div>
          </InlineGrid>
        </div>
      </InlineGrid>
      <Divider />
    </>
  );
};

export default ProductLabels;
